import { useEffect, useState } from "react"

export default function useFormField(predefinedValue, validateField, globalValue, setGlobalValue, setError) {
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    if (predefinedValue && globalValue === undefined) {
      setGlobalValue(predefinedValue)
    }
  }, [])

  useEffect(() => {
    if (predefinedValue) {
      const initialError = validateField(predefinedValue)
      setError(initialError)
    }
  }, [])

  const handleFocus = () => {
    setIsFocused(true)
    setError("")
  }

  const handleBlur = (e) => {
    setIsFocused(false)
    const value = e.target.value
    validate(value)
  }

  const handleBlurFiles = (files) => {
    setIsFocused(false)
    validate(files)
  }

  const handleCheckboxBlur = (values) => {
    setIsFocused(false)
    validate(values)
  }

  const handleChange = (e) => {
    const newValue = e.target.value
    setGlobalValue(newValue)
  }

  const handleFileChange = (files) => {
    setGlobalValue(files)
    setIsFocused(false)
    validate(files)
  }

  const validate = (value) => {
    const errorMsg = validateField(value)
    setError(errorMsg)
    return errorMsg
  }

  const handleDateChange = (e) => {
    const newValue = e.target.value
    setGlobalValue(newValue)
    setIsFocused(false)
    validate(newValue)
  }

  const handleSelectionChange = (value) => {
    setGlobalValue(value)
    setIsFocused(false)
    validate(value)
  }

  return {
    value: globalValue,
    isFocused,
    handleFocus,
    handleBlur,
    handleChange,
    handleDateChange,
    handleSelectionChange,
    handleCheckboxBlur,
    handleBlurFiles,
    handleFileChange,
  }
}
